<style lang="less" rel="stylesheet/less" scope>
 .upload-wrapper {
   text-align: center;
   .template-link {
     padding-bottom: 15px;
     display: inline-block;
     color: #00a0e8;
     &:hover {
       text-decoration: underline;
     }
   }
 }
</style>
<template>
  <div class="upload-wrapper">
    <!-- <a class="template-link" :href="api + templateLink"></a> -->
    <el-button type="text" @click="handleExport">导入模板下载</el-button>
    <el-upload
      class="upload-demo"
      ref="upload"
      with-credentials
      :multiple="false"
      :headers="headers"
      :action="importApi + fileUploadLink"
      :before-upload="beforeupload"
      :on-error="handleError"
      :on-success="handleSuccess"
      :on-change="handleChange"
      :file-list="fileList"
      :auto-upload="false">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传文件</el-button>
      <div slot="tip" class="el-upload__tip">仅支持按模版格式的excel导入</div>
    </el-upload>
  </div>
</template>
<script type='text/ecmascript-6'>
  import { mapState } from 'vuex'
  import store from '@/store/index'
  import { handleExport } from '@/utils/blob-download';
  import { logout } from '@/utils/logout.js';
  import { Message } from 'element-ui';
  export default  {
    name: 'LyUploadTemplate',
    props: {
      fileUploadLink: {
        type: String,
        default: ''
      },
      templateLink: {
        type: String,
        default: ''
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      fileList: [],
      token: '',
      api: '',
      headers: {
        Authorization: ''
      }
    }),
    created() {
      ({ BASE_API: this.api, IMPORT_API: this.importApi } = store.getters.objApi);
      this.token = store.getters.token.access_token;
      this.headers.Authorization = store.getters.token.token_type + ' ' + store.getters.token.access_token;
    },
    watch: {
      visible(val) {
        if (val) {
          this.fileList = [];
        }
      }
    },
    methods: {
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleSuccess(response, file, fileList) {
        this.$emit('success', response);
      },
      handleError(err, file, fileList) {
        if (err.status === 401) {
          logout();
        }
        this.$emit('error', err);
      },
      async beforeupload() {
        const token = await store.dispatch('GetToken');
        this.headers.Authorization = store.getters.token.token_type + ' ' + store.getters.token.access_token;
      },
      handleChange(file, fileList) {
        if(fileList.length>1){
          fileList.splice(0,1);
        }
      },
      handleExport() {
        handleExport({
          url: this.templateLink,
          callback: () => {}
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/upload-template/index.vue